import { CallbackCache } from '../../common/CallbackCache';
import { UserErrorResponse } from '../../services/common/serviceError';
import { UserResponse } from './ServiceErrorCallback';

export default class UserResponseCallbackCache extends CallbackCache<UserErrorResponse, UserResponse> {}
